const buttonVariants = {
  root: {
    px: [2, 3, 3],
    py: 2,
    // hack to keep border inside
    // height: 'scale.7',
    height: 'auto',
    variant: 'text.body2',
    lineHeight: '1',
    borderRadius: 'circle',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'white',
    color: 'white',
    flex: '0 0 auto',
    alignSelf: 'center',
    '&[disabled]': {
      opacity: 0.5,
      pointerEvents: 'none',
    },
    '& > svg': {
      verticalAlign: 'middle',
      size: 16,
      margin: '-1px',
    },
  },
  primary: {
    variant: 'buttons.root',
    bg: 'primary',
    borderColor: 'primary',
    '&:hover': {
      bg: 'primaryHover',
      borderColor: 'primaryHover',
    },
  },
  success: {
    variant: 'buttons.root',
    bg: 'statusSuccess',
    borderColor: 'statusSuccess',
    '&:hover': {
      bg: 'statusSuccess',
      borderColor: 'statusSuccess',
    },
  },
  secondary: {
    variant: 'buttons.root',
    bg: 'secondary',
    borderColor: 'secondary',
    '&:hover': {
      bg: 'secondaryHover',
      borderColor: 'secondaryHover',
    },
  },
  danger: {
    variant: 'buttons.root',
    bg: 'danger',
    borderColor: 'danger',
    '&:hover': {
      bg: 'dangerHover',
      borderColor: 'dangerHover',
    },
  },
  outline: {
    variant: 'buttons.root',
    bg: 'field',
    color: 'onField',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'fieldBorder',
    '&:hover': {
      bg: 'fieldBorder',
      borderColor: 'fieldBorder',
    },
  },
  utility: {
    py: 1,
    px: 2,
    variant: 'text.subheading',
    borderRadius: 'circle',
    color: 'text',
    bg: 'utilBtn',
    borderColor: 'utilBtn',
    display: 'inline-flex',
    '&:hover': {
      bg: 'utilBtnHover',
      borderColor: 'utilBtnHover',
      cursor: 'pointer',
    },
  },
  utilityDark: {
    variant: 'buttons.utility',
    color: 'white',
    bg: 'secondary',
    borderColor: 'secondary',
    '&:hover': {
      bg: 'secondaryHover',
      borderColor: 'secondaryHover',
      cursor: 'pointer',
    },
  },
  utilityIcon: {
    variant: 'buttons.utility',
    size: 24,
    p: 0,
    alignItems: 'center',
    justifyContent: 'center',
    flex: '0 0 24px',
    '&[disabled]': {
      opacity: 0.25,
      pointerEvents: 'none',
    },
  },
  utilityIconDark: {
    variant: 'buttons.utilityIcon',
    color: 'white',
    bg: 'secondary',
    borderColor: 'secondary',
    '&:hover': {
      bg: 'secondaryHover',
      borderColor: 'secondaryHover',
      cursor: 'pointer',
    },
  },
  utilityIconDanger: {
    variant: 'buttons.utilityIcon',
    color: 'white',
    bg: 'danger',
    borderColor: 'danger',
    '&:hover': {
      bg: 'dangerHover',
      borderColor: 'dangerHover',
      cursor: 'pointer',
    },
  },
};

export default buttonVariants;
